import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IHomeBlogArticleItem {
  id: number;
  symbol: string;
  section_id_symbol: string;
  title: string;
  subtitle?: string;
  content?: string;
  background_picture?: string;
  layouts?: unknown;
  lp?: unknown;
  url_key: string;
  url_to_all_articles?: string;
  is_news?: boolean;
  is_tutorial?: boolean;
  is_popular?: boolean;
}

export interface IHomeBlogArticlesResponse {
  page: number;
  total_count: number;
  total_pages: number;
  items: IHomeBlogArticleItem[];
}


const getHomeBlogArticles = (sectionSymbol: string, page = 1): Promise<IHomeBlogArticlesResponse> => {
  return axios.get(`/home/blog/articles/${encodeURIComponent(sectionSymbol)}`, {
    params: { page }
  });
};

export const useGetHomeBlogArticles = (
  sectionSymbol: string,
  options?: Omit<UseQueryOptions<IHomeBlogArticlesResponse, IError>, 'queryKey' | 'queryFn'> & {
    page?: number;
  }
) => {
  const { page = 1, ...queryOptions } = options ?? {};
  return useQuery<IHomeBlogArticlesResponse, IError>(
    ['home-blog-articles', sectionSymbol, page],
    () => getHomeBlogArticles(sectionSymbol, page),
    {
      enabled: Boolean(sectionSymbol),
      ...queryOptions
    }
  );
};
